/// <reference path="./module-type.d.ts" />
import { MuiThemeProvider } from '@material-ui/core/styles';
import { ConnectedRouter } from 'connected-react-router';
import * as React from 'react';
import { Provider } from "react-redux";
import theme from './app-theme';
import './App.css';
import RouterComponent from './routes/routerComponent';
import {configStore, history} from './store/config';
const store = configStore();

class App extends React.Component {
  render() {
    return (
      <MuiThemeProvider theme={theme}>
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <RouterComponent />
        </ConnectedRouter>
      </Provider>
      </MuiThemeProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx